import { render, staticRenderFns } from "./ElementsTree.vue?vue&type=template&id=a416c60c&scoped=true"
import script from "./ElementsTree.vue?vue&type=script&lang=js"
export * from "./ElementsTree.vue?vue&type=script&lang=js"
import style0 from "./ElementsTree.vue?vue&type=style&index=0&id=a416c60c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a416c60c",
  null
  
)

export default component.exports